import type { Filters, FormValues } from 'pages/clusters/types';

/**
 * Transform the entry filters (topbar) to how the API expects them to be used
 * @param entryFilters
 * @returns API ready filters
 */
export const transformEntryFilters = (
  entryFilters: FormValues | undefined
): Record<string, number | number[] | string | string | undefined> => ({
  'testInstance.customer.customerGroupsCustomers.customerGroup': entryFilters?.cluster,
  'testInstance.test': entryFilters?.test,
  'testInstance.startDate[after]': entryFilters?.period.startDate,
  'testInstance.endDate[before]': entryFilters?.period.endDate
});

/**
 * Transform the filters (sidebar) to how the API expects them to be uses
 * @param filters
 * @returns API ready filters
 */
export const transformFilters = (
  filters: Filters | undefined
): Record<string, number[] | undefined> => ({
  'user.user.user.gender': filters?.genders?.map(({ id }) => id),
  'user.user.user.ethnicities': filters?.ethnicities?.map(({ id }) => id),
  'user.level': filters?.levels?.map(({ id }) => id),
  'testInstance.customer.customerGroupsCustomers': filters?.clusterCustomers?.map(({ id }) => id)
});
